import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import { useMedia } from '@/shared/hooks';

import { Icon } from '../Icon/Icon';

import styles from './Back.module.scss';

type BackProps = {
  className?: string;
  testID?: string;
  onClick?: () => void;
};

export const Back: FC<BackProps> = (props) => {
  const { className, testID, onClick } = props;

  const { isMobile } = useMedia();
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick();
      return;
    }

    navigate(-1);
  };

  return (
    <nav
      className={cn(
        styles.container,
        isMobile && styles.mobileContainer,
        className,
      )}
      data-testid={testID}
    >
      <button
        type="button"
        onClick={handleBack}
        className={cn(styles.backButton, 'p1')}
      >
        <Icon className={styles.backButtonIcon} name="arrowDown" size={32} />

        <FormattedMessage id="navigation.back" defaultMessage="Back" />
      </button>
    </nav>
  );
};
